module.exports = __webpack_public_path__ + "img/knitting.be5030ca.webp";